import './DeclarationPeriods.css';

import {useState} from "react";
import {Modal, Snack, Snackbar, Spinner, Text, Tooltip, Button} from "@nike/eds";
import {DeclarationPeriodsTable} from "../components/declaration-periods-table/DeclarationPeriodsTable";
import {useDeclarationPeriodsTable} from "./useDeclarationPeriodsTable";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {CopyPaste} from "@nike/nike-design-system-icons";

export function DeclarationPeriods() {
    const { downloadError, dismissDownloadError, payloadContent, payloadLoading, dismissPayloadContent, ...tableProps } = useDeclarationPeriodsTable();
    const [copied, setCopied] = useState(false);

    return (
        <div className="declaration-periods-page">
            <Snackbar>
                {downloadError && (
                    <Snack id="download-error" status="error" onDismiss={dismissDownloadError} autoDismissDuration={15000}>
                        <p className="eds-type--body-2">{downloadError}</p>
                    </Snack>
                )}
            </Snackbar>
            <DeclarationPeriodsTable
                {...tableProps}
                tableTitle={<Text font="title-2" as="h2">Declaration Periods</Text>}
            />
            <Modal
                isOpen={payloadLoading || payloadContent !== null}
                onDismiss={dismissPayloadContent}
                headerSlot="Payload"
                footerSlot={
                    <div className="eds-flex eds-gap--16 modal-footer-actions">
                        <Tooltip bodySlot={copied ? "Copied!" : "Copy to clipboard"}>
                            <CopyToClipboard text={payloadContent ?? ""} onCopy={() => setCopied(true)}>
                                <Button
                                    size="small"
                                    beforeSlot={<CopyPaste />}
                                    disabled={payloadLoading || !payloadContent}
                                >
                                    Copy to clipboard
                                </Button>
                            </CopyToClipboard>
                        </Tooltip>
                    </div>
                }
            >
                <div className="payload-modal-content">
                    {payloadLoading ? (
                        <div className="payload-spinner-container">
                            <Spinner />
                        </div>
                    ) : (
                        <pre className="payload-content">
                            {payloadContent}
                        </pre>
                    )}
                </div>
            </Modal>
        </div>
    );
}